import React, { Component } from "react";
import "./administrador.css";
import { Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import Utils from "../../Utils";
import { Cargando } from '../estados/Cargando';

export class Niveles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalNiv: props.modalNiv,
            niveles: [],
            estado: false,
            rol: props.rol
        };

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.getgetNiveles();
    }

    toggle = () => {
        this.props.modalNiv();
    }

    async getgetNiveles() {
        this.setState({ estado: false })
        await Utils.getNiveles()
            .then(data => {
                if (data !== undefined) {
                    this.setState({ niveles: data, estado: true })

                }
            });
    }

    async sendForm() {
        let balance = -1;
        let json = "[";
        for (const elem of this.inputRef.current.elements) {
            switch (elem.name) { 
                case "numero": json += `{"numero":${elem.value},`; break;
                case "frase": json += `"frase":"${elem.value}",`; break;
                case "minimo":
                    if (balance < Number(elem.value)) balance = Number(elem.value);
                    else {
                        alert("� Error: Niveles desbalanceados �");
                        return;
                    }
                    json += `"minimo":${elem.value},`;
                    break;
                case "maximo":
                    if (balance < Number(elem.value)) balance = Number(elem.value);
                    else {
                        alert("� Error: Niveles desbalanceados �");
                        return;
                    }
                    json += `"maximo":${elem.value}},`;
                    break;
                default: ;
            }
        }
        json = json.slice(0, -1) + "]";
        if (this.state.rol === "A")
            await Utils.setNiveles(json);
    }

    cambioHandler(niv, nuevoValor) {
        if (nuevoValor.name !== 'frase') {
            nuevoValor.value = nuevoValor.value.replace(/[^0-9]/g, '')
            if (Number(nuevoValor.value) > 99) nuevoValor.value = 99;
            if (Number(nuevoValor.value) < 3) nuevoValor.value = 2
        }
        const nuevosNiveles = this.state.niveles.map((input) => {
            if (input.numero === niv.numero) {
                switch (nuevoValor.name) {
                    case "numero": input.numero = nuevoValor.value;
                        break;
                    case "frase": input.frase = nuevoValor.value;
                        break;
                    case "minimo": input.minimo = nuevoValor.value;
                        break;
                    case "maximo": input.maximo = nuevoValor.value;
                        break;
                    default:
                        break;
                }
            }
            return input;
        });
        if (nuevoValor.name === 'maximo')
            nuevosNiveles[niv.numero].minimo = Number(nuevoValor.value) + 1;
        
        if (this.state.rol === "A")
            this.setState({ niveles: nuevosNiveles });
    }

    render() {
        return (
            <>
                {!this.state.estado ? <div><Cargando></Cargando></div> :
                    <>
                        <ModalHeader toggle={() => this.toggle()}>Valores de Niveles</ModalHeader>
                        <ModalBody>
                            <form id="nivelForm" ref={this.inputRef}>
                                <table>
                                    <tbody className="beneficiosEdit">
                                        {this.state.niveles.map((nivel) => (
                                            <>
                                                <tr>
                                                    <td> Nivel {nivel.numero} </td>
                                                    <td> <Input type="hidden" name="numero" value={nivel.numero} /> </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <FormGroup>
                                                            <Label for="fraseNivel">Frase</Label>
                                                            <Input id="fraseNivel" name="frase" placeholder="Frase" type="text" value={nivel.frase} onChange={(e) => this.cambioHandler(nivel, e.target)} />
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        Desde: <input type="number" name="minimo" max="100" min="0" value={nivel.minimo} disabled />
                                                        <br />
                                                        Hasta:&nbsp; <input type="number" name="maximo" max="100" min="0" value={nivel.maximo} onChange={(e) => this.cambioHandler(nivel, e.target)} disabled={nivel.numero>4} />
                                                    </td>
                                                </tr>
                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            {this.state.rol === "A" ?
                                <Button color="primary" onClick={() => this.sendForm()}>
                                    Guardar
                                </Button> : null
                            }
                            {' '}
                            <Button color="secondary" onClick={() => this.toggle()}>
                                Cerrar
                            </Button>
                        </ModalFooter>
                    </>
                }
            </>
        );
    }
}